import React from 'react';
import PropTypes from 'prop-types';

import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import StandardModal from 'components/consumer/StandardModal';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import IconDimensions from 'components/icons/IconDimensions';
import { colorBrandDark } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';

const PDPDimensionsModal = ({ isOpen = false, onClose }) => (
  <StandardModal
    className="PDPDimensionsUI"
    isOpen={isOpen}
    size="xl"
    theme="light"
    onClose={onClose}
  >
    <FixedWidthContainer>
      <div className="items-center flex justify-center mt-12 mx-auto mb-8">
        <span className="items-center bg-brand-lightest flex h-11 justify-center mr-4 w-11">
          <IconDimensions color={colorBrandDark} />
        </span>
        <span className="text-3xl font-bold text-gray">Dimensions</span>
      </div>

      <PDPDimensionsContent />
    </FixedWidthContainer>
  </StandardModal>
);

PDPDimensionsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withBrowserOnly(PDPDimensionsModal);
